import { render, staticRenderFns } from "./SaleRecords.vue?vue&type=template&id=e80fcaee"
import script from "./SaleRecords.vue?vue&type=script&lang=js"
export * from "./SaleRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports